import { Backdrop, makeStyles } from "@material-ui/core";
import { Fragment, useEffect, useState } from "react";
import CloseIcon from '@material-ui/icons/Close';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useDispatch, useSelector } from "react-redux";
import JsFileDownloader from 'js-file-downloader';
import { deleteAccountDoc } from "../../../../actions/driverAppApprovalActions";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: '#fff',
    width: '100%'
  },
  background: {
    display: 'flex',
    flexDirection: 'column',
    height: 700,
    width: 900,
    border: 'solid 1px #636463',
    backgroundColor: '#262626',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  photoSection: {
    height: 600,
    width: 900,
  },
  operateSection: {
    height: 100,
    width: 900,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderTop: 'solid 1px #636463',
    backgroundColor: '#262626',
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  iconStyle: {
    width: 55,
    height: 55,
    marginTop: 22,
    cursor: 'pointer'
  }
}));

function SlideShow(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {t} = useTranslation('driverApproval');

  const [open, setOpen] = useState(false);
  const [degree, setDegree] = useState(0);
  const [index, setIndex] = useState(0);
  const [slideImages, setSlideImages] = useState([]);

  const IMAGE_TOTAL_NUM = 4;

  function handleClose() {
    setOpen(false);
    props.handleClose();
  }
  function handleRotate(direction) {
    let degreeCopy = degree;
    if(direction === 'left') {
      degreeCopy -= 90;
    } else {
      degreeCopy += 90;
    }
    setDegree(degreeCopy);
  }
  function handleSlide(type) {
    let indexCopy = index;
    indexCopy = type === -1 ? indexCopy - 1 : indexCopy + 1;
    indexCopy %= slideImages.length;
    setIndex(indexCopy);
  }
  function handleDownload(url, name) {
    const download = new JsFileDownloader({ 
      url: url,
      autoStart: false,
      filename: name
    });
    download.start();
  }
  function handleDelete(index) {
    handleClose();
    props.deleteCache(index)
  }

  useEffect(() => {
    setOpen(props.open)
    if(props.open) {
      setSlideImages(props.slideImages)
      if(props.indexSlide >=0 && props.indexSlide < IMAGE_TOTAL_NUM) {
        setIndex(props.indexSlide)
      } else {
        setIndex(0)
      }
    }
    
  }, [props.open])

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <div 
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: 40,
          right: 40
        }}
      >
         <CloseIcon />
      </div>
      {
        slideImages &&
        slideImages.length > 0 &&
        <TransformWrapper
          initialScale={1}
          // initialPositionX={200}
          // initialPositionY={100}
          initialPositionX={0}
          initialPositionY={0}
        >
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <div>
              <div 
                style={{
                  textAlign: 'center', 
                  fontSize: 24,
                  fontWeight: 500,
                  marginBottom: 17,
                  color: '#e4e4e3'
                }}
              >
                {
                  slideImages[index].name ?
                  t(`${slideImages[index].name}`) :
                  slideImages[index].doc_type
                }
              </div>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <div 
                  onClick={() => {
                    if(index !== 0) {
                      handleSlide(-1);
                    }
                  }}
                >
                  <ChevronLeftIcon 
                    style={
                      index === 0 ?
                      {
                        height: 180,
                        width: 90,
                        color: '#9e9e9e'
                      } : {
                        height: 180,
                        width: 90,
                        color: '#ff9d00'
                      }
                    }
                  />
                </div>
                <div
                  className={classes.background}
                >
                  <div className={classes.photoSection}>
                    <TransformComponent>
                      <img 
                        src={slideImages[index].access_url || slideImages[index].preview}
                        style={{ 
                          transform: `rotate(${degree}deg)`,
                          maxWidth: 900,
                          maxHeight: 600
                        }}
                      />
                    </TransformComponent>
                  </div>
                  <div className={classes.operateSection}>
                    <div style={{width: '45%', display: 'flex', justifyContent: 'space-evenly'}}>
                      {
                        props.type !== 'approval' &&
                        <img
                          src='/images/icons/delete.svg'
                          className={classes.iconStyle}
                          onClick={()=>handleDelete(index)}
                        />
                      }
                      <ZoomInIcon 
                        className={classes.iconStyle}
                        onClick={() => zoomIn()} 
                      />
                      <ZoomOutIcon 
                        className={classes.iconStyle}
                        onClick={() => zoomOut()} 
                      />
                    </div>
                    <div style={{width: '10%', display: 'flex'}}>
                      <CloudDownloadIcon
                        className={classes.iconStyle}
                        onClick={() => {
                          if(slideImages[index].document) {
                            handleDownload(slideImages[index].document, slideImages[index].type)
                          } else if(slideImages[index].access_url) {
                            handleDownload(slideImages[index].access_url, slideImages[index].doc_type)
                          }
                        }}
                      />
                    </div>
                    <div style={{width: '45%', display: 'flex', justifyContent: 'space-evenly'}}>
                      <RotateLeftIcon
                        className={classes.iconStyle}
                        onClick={() => {
                          handleRotate('left')
                        }}
                      />
                      <RotateRightIcon
                        className={classes.iconStyle}
                        onClick={() => {
                          handleRotate('right')
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div 
                  onClick={() => {
                    if(index !== slideImages.length - 1) {
                      handleSlide(+1);
                    }
                  }}
                >
                  <ChevronRightIcon
                    style={
                      index === slideImages.length - 1 ?
                      {
                        height: 180,
                        width: 90,
                        color: '#9e9e9e'
                      } : {
                        height: 180,
                        width: 90,
                        color: '#ff9d00'
                      }
                    }
                  />
                </div>
              </div>
            </div>
          )}
        </TransformWrapper>
      }
    </Backdrop>
  )
};

export default SlideShow;
